import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito experiencia previa en cocina?',
    answer: 'No. El Tomo 1 arranca desde cero y te lleva de la mano paso a paso. Todo está explicado con lenguaje simple, sin términos técnicos.'
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Inmediatamente después del pago. Recibís un mail con el link de descarga de todos los PDFs. Acceso al instante, las 24 horas.'
  }, {
    question: '¿En qué formato está el material?',
    answer: 'En PDF descargable, optimizado para leer en celular, tablet o computadora. 100% digital.'
  }, {
    question: '¿Puedo empezar a vender rápido?',
    answer: 'Sí. Muchas emprendedoras tienen su primer producto listo en 24 a 48 horas de haber comprado el pack.'
  }, {
    question: '¿Los ingredientes son fáciles de conseguir en Argentina?',
    answer: 'Sí. Todo el material está pensado para conseguirse en supermercados y negocios de repostería locales.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 7 días de garantía total. Si no estás conforme, te devolvemos el 100% sin hacer preguntas.'
  }, {
    question: '¿Puedo usar el material para enseñar o revender?',
    answer: 'No. El material es de uso personal. No está permitida su reproducción, venta ni distribución.'
  }];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-50 text-center mb-3 md:mb-6" data-id="element-51">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>

          <div className="space-y-2" data-id="element-52">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="bg-neutral-900 border border-amber-900/40 rounded-lg overflow-hidden" data-id="element-53">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-neutral-800 transition-colors" data-id="element-54">
                  <span className="text-base font-semibold text-amber-50 pr-4" data-id="element-55">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-amber-400 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-56" />
                </button>
                <AnimatePresence data-id="element-57">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-58">
                      <div className="px-4 pb-4 text-neutral-300 text-sm leading-relaxed" data-id="element-59">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}